<template>
<div>
  <!-- 总榜单 -->
  <div v-if="showMulti" class="multi-type-wrapper">
    <template v-if="!(types.length===1)">
       <div
        v-for="type in types"
        :key="type.cateId"
        class="types_container_multi multi"
        :class="{
          'selected': selectedType === type.cateId,
          'no-selected': selectedType !== type.cateId,
        }"
        @click="$emit('tapType', type)"
      >
        <img :src="selectedType === type.cateId ? type.imgSelected : type.img" />
        <div class="desc">
          <p>{{type.title}}</p>
          <span class="line"></span>
        </div>
      </div>
    </template>
    <div v-else class="types_container_multi single">
      <img :src="types[0].imgSelected" />
      <div v-if="subItems.length===1" class="desc"><p>{{`${types[0].title} - ${subItems[0].title}`}}</p></div>
      <div v-else class="desc"><p>{{ types[0].title }}</p></div>
    </div>
  </div>
  <!-- 三榜单 -->
  <div v-else-if="types.length===3" class="types_container_3">
    <div class="type_item" v-for="type in types" :key="type.cateId" @click="$emit('tapType', type)">
      <div v-if="selectedType === type.cateId" class="selected">
        <img class="bg_img" :src="type.bgImgSelected" />
        <img class="icon" :src="type.imgSelected" />
        <div :class="['desc_container', type.cateId === '1' ? 'close_both' : '']">
          <img class="left" :src="type.leftIcon" />
          <div class="desc">{{type.title}}</div>
          <img class="right" :src="type.rightIcon" />
        </div>
      </div>
      <div v-else>
        <img class="bg_img" :src="type.bgImg" />
        <img class="icon" :src="type.img" />
        <div class="desc_container">
          <div class="desc">{{type.title}}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- 两榜单 -->
  <div v-else-if="types.length===2" class="types_container_2">
    <div class="type_item" v-for="type in types" :key="type.cateId" @click="$emit('tapType', type)">
      <div v-if="selectedType === type.cateId" class="selected"><!-- 选中 -->
        <img class="bg_img" :src="type.bgImgFeatureSelected" />
        <div class="icon_container">
          <img class="icon" :src="type.imgSelected" />
        </div>
        <div class="desc_container">
          <img :src="type.leftIcon" />
          <div class="desc">{{type.title}}</div>
          <img :src="type.rightIcon" />
        </div>
      </div>
      <div v-else><!-- 未选中 -->
        <img class="bg_img" :src="type.bgImgFeature" />
        <div class="icon_container">
          <img class="icon" :src="type.img" />
        </div>
        <div class="desc_container">
          <div class="desc">{{type.title}}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- 一榜单 -->
  <div v-else-if="types.length===1">
    <div v-if="subItems.length > 1" class="types_container_1">
      <img :src="types[0].img" />
      <div class="desc">{{types[0].title}}</div>
    </div>
    <div v-else class="types_container_1">
      <img :src="types[0].img" />
      <div class="desc">{{`${types[0].title} -`}}</div>
      <div class="desc_sub">&nbsp;{{subItems[0].title}}</div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    selectedType: {
      type: String,
      default: '2',
    },
    types: {
      type: Array,
      default: [],
    },
    subItems: {
      type: Array,
      defalut: [],
    },
    showMulti: {
      type: Boolean
    }
  },
  computed: {
    is3() {
      return this.types.length === 3;
    }
  }
}
</script>
<style lang="scss" scoped>
.multi-type-wrapper {
  padding: 0 32px 0 16px;
  display: flex;
  align-items: center;
  width: 100vw;
  box-sizing: border-box;
  .types_container_multi {
    margin-right: 60px;
    white-space: nowrap;
    overflow: hidden;
    img {
      display: inline-block;
      width: 56px;
      height: 56px;
      vertical-align: middle;
    }
    .desc {
      display: inline-block;
      margin-left: 8px;
      max-width: calc(100% - 64px);
      p {
        line-height: 28px;
        font-family: DiDiSans-Pro-Medium;
        font-size: 28px;
        color: #975425;
        text-align: left;
        font-weight: 500;
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;/*隐藏后添加省略号*/
        -webkit-box-orient:vertical; 
        -webkit-line-clamp:1; //想显示多少行
      }
      .line {
        display: none;
      }
    }
    &.single {
      .desc {
        vertical-align: middle;
        p {
          font-family: DiDiSans-Pro-Bold;
          line-height: 48px;
          font-size: 40px;
          font-weight: 700;
        }
      }
    }
    &.selected {
      max-width: 62.5%;
      img {
        width: 72px;
        height: 72px;
      }
      .desc {
        margin-top: 8px;
        vertical-align: top;
        // max-width: calc(100% - 80px);
        p {
          font-family: DiDiSans-Pro-Bold;
          line-height: 44px;
          font-size: 36px;
          font-weight: 700;
        }
        .line {
          display: block;
          margin-top: 8px;
          height: 4px;
          border-radius: 3px;
          background-color: #975425;
        }
      }
    }
    &:last-child {
      margin-right: 0;
    }
    &:only-child {
      max-width: 100%;
    }
  }
  
}
.types_container_3 {
  width: 686px;
  margin-left: 32px;
  display: flex;
  justify-content: space-between;
  .type_item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .bg_img {
      width: 216px;
      height: 186px;
    }
    .icon {
      position: absolute;
      top: -10px;
      left: 42px;
      width: 132px;
      height: 132px;
    }
    .desc_container {
      position: absolute;
      bottom: 0;
      width: 216px;
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 28px;
        height: 28px;
        &.left {
          transform: translateX(7px);
        }
        &.right {
          transform: translateX(-7px);
        }
      }
      // &.close_both {
      //   .left {
      //     transform: translateX(17px);
      //   }
      //   .right {
      //     transform: translateX(-17px);
      //   }
      // }
      .desc {
        font-family: DiDiSans-Pro-Medium;
        font-size: 28px;
        color: #975425;
        letter-spacing: 0;
        text-align: center;
        line-height: 28px;
        font-weight: 500;
        max-width: 155px;
        display:-webkit-box;
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;/*隐藏后添加省略号*/
        -webkit-box-orient:vertical; 
        -webkit-line-clamp:2; //想显示多少行
      }
    }
    .selected {
      .icon {
        top: -54px;
        left: 34px;
        width: 148px;
        height: 148px;
      }
      .desc {
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        color: #975425;
        letter-spacing: 0;
        text-align: center;
        line-height: 28px;
        font-weight: 700;
      }
    }
  }
}
.types_container_2 {
  width: 686px;
  margin-left: 32px;
  display: flex;
  justify-content: space-between;
  .type_item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .bg_img {
      width: 333px;
      height: 184px;
    }
    .icon_container {
      width: 333px;
      position: absolute;
      left: 0px;
      bottom: 66px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        width: 132px;
        height: 132px;
      }
    }
    .desc_container {
      width: 333px;
      position: absolute;
      bottom: 0;
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 28px;
        height: 28px;
      }
      .desc {
        font-family: DiDiSans-Pro-Medium;
        font-size: 28px;
        color: #975425;
        letter-spacing: 0;
        text-align: center;
        line-height: 28px;
        font-weight: 500;
        max-width: 310px;
        display:-webkit-box;
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;/*隐藏后添加省略号*/
        -webkit-box-orient:vertical; 
        -webkit-line-clamp:2; //想显示多少行
      }
    }
    .selected {
      width: 333px;
      //kaishi
      .bg_img {
        width: 333px;
        height: 184px;
      }
      .icon_container {
        width: 333px;
        position: absolute;
        left: 0px;
        bottom: 96px;
        .icon {
          width: 148px;
          height: 148px;
        }
      }
      .desc_container {
        width: 333px;
        position: absolute;
        bottom: 0;
        height: 92px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 28px;
          height: 28px;
        }
        .desc {
          font-family: DiDiSans-Pro-Bold;
          font-size: 28px;
          color: #975425;
          letter-spacing: 0;
          text-align: center;
          line-height: 28px;
          font-weight: 700;
        }
      }
      //jieshu
    }
  }
}
.types_container_1 {
  margin-left: 32px;
  display: flex;
  align-items: center;
  img {
    width: 54px;
    height: 54px;
  }
  .desc {
    margin-left: 13px;
    height: 54px;
    line-height: 54px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 40px;
    color: #975425;
    text-align: left;
    font-weight: 700;
    letter-spacing: -1px;
  }
  .desc_sub {
    color: #975425;
    font-family: DiDiSans-Pro-Bold;
    font-size: 36px;
    color: #975425;
    text-align: left;
    font-weight: 500;
    letter-spacing: -1px;
  }
}
</style>